import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';


function extractYouTubeId(url) {
    if (!url) return null;
    const patterns = [
        /(?:youtube\.com\/watch\?v=)([^&\s]+)/,
        /(?:youtu\.be\/)([^?\s]+)/,
        /(?:youtube\.com\/embed\/)([^?\s]+)/,
        /(?:youtube\.com\/shorts\/)([^?\s]+)/
    ];
    for (const pattern of patterns) {
        const match = url.match(pattern);
        if (match) return match[1];
    }
    return null;
}

function getDomain(url) {
    try { return new URL(url).hostname.replace('www.', ''); } catch { return url; }
}

const CardViewer = () => {
    const { id } = useParams();
    const [card, setCard] = useState(null);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const fetchCard = async () => {
            const docRef = doc(db, 'cards', id);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                setCard(docSnap.data());
            } else {
                setCard(null);
            }
            setLoading(false);

        };
        fetchCard();
    }, [id]);
    if (loading) return <p className="text-center mt-10">Loading card...</p>;

    if (!card) {
        return <p className="text-center mt-10">Card not found.</p>;
    }

    return (
        <div className={`min-h-screen flex items-center justify-center ${card.gradient}`}>
            <div className="max-w-lg p-6 rounded-xl text-white text-lg shadow-lg" style={{ color: card.textColor }}>
                {/* ✅ Show uploaded image */}
                {card.imageURL ? (
                    <img src={card.imageURL} alt="Uploaded" className="w-full mb-4 rounded" />
                ) : card.imageData ? (
                    <img src={card.imageData} alt="Uploaded" className="w-full mb-4 rounded" />
                ) : null}
                {card.mode === 'Classic' && (
                    <>
                        <p className="font-bold text-xl mb-2">Dear {card.recipient},</p>
                        {card.emotion && <p className="italic mb-4">Expressing {card.emotion}:</p>}
                    </>
                )}
                <p className="whitespace-pre-line">{card.message}</p>

                {card.url && extractYouTubeId(card.url) && (
                    <div className="mt-4 rounded-lg overflow-hidden aspect-video">
                        <iframe
                            src={`https://www.youtube.com/embed/${extractYouTubeId(card.url)}`}
                            className="w-full h-full"
                            allow="encrypted-media"
                            allowFullScreen
                            title="YouTube video"
                        />
                    </div>
                )}

                {card.url && !extractYouTubeId(card.url) && (
                    <a
                        href={card.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-white/80 text-sm hover:underline flex items-center gap-1 mt-4"
                    >
                        🔗 {getDomain(card.url)}
                    </a>
                )}

                {card.mode === 'Classic' && (
                    <>
                        <p className="text-right text-sm">Yours,</p>
                        <p className="text-right font-bold">{card.sender}</p>
                    </>
                )}
            </div>
        </div>
    );
};

export default CardViewer;
